import React, { FC, ReactNode } from 'react';
import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface HeaderProps extends StyleProps {
  title: string;
  isConsultingServiceHeader?: boolean;
  description?: string;
}

type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      // padding: theme.spacing(20, 0, 16),
      marginTop: 0,
      minHeight: 400,
      maxHeight: 800,
      backgroundPosition: 'center',
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(20, 0, 16),
        marginTop: theme.spacing(13.5),
      },
    },
    title: {
      color: theme.palette.common.white,
      fontWeight: 700,
      maxWidth: 930,
      textAlign: 'center',
      margin: 'auto',
    },
    description: {
      color: theme.palette.common.white,
      fontWeight: 400,
      maxWidth: 930,
      textAlign: 'center',
      margin: 'auto',
      fontSize: 16,
      [theme.breakpoints.up('md')]: {
        fontSize: 23,
      },
    },
    container: {
      justifyContent: 'center',
      display: 'flex',
    },
  });
});

const Header: FC<HeaderProps> = ({ title, image, isConsultingServiceHeader = false, description }) => {
  const classes = useStyles({ image });
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <Box className={`${classes.root} ${isConsultingServiceHeader ? classes.container : ''}`}>
      <Container className={isConsultingServiceHeader ? classes.container : ''} fixed>
        <Grid style={{ margin: 'auto' }}>
          <Grid item xs={12}>
            <Typography variant={isMediumUp ? 'h1' : 'h2'} className={classes.title} data-aos="fade-up" data-aos-duration="700">
              {title}
            </Typography>
          </Grid>

          {!!description && (
            <Grid item xs={12}>
              <Typography className={classes.description} data-aos="fade-up" data-aos-duration="700">
                {description}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Container>
      <Box id={'background'} />
    </Box>
  );
};

export default Header;
